import { Descriptions } from 'antd'

import { JsonHighlightViewer } from '@eastcoal/common/components/JsonHighlightViewer'

import { TemplateVariableDetailProps } from './interface'

export const TemplateVariableDetail = ({
  data: { name, description, mockValue }
}: TemplateVariableDetailProps) => {
  return (
    <Descriptions
      column={1}
      items={[
        {
          key: 'name',
          label: '参数名称',
          children: name
        },
        {
          key: 'description',
          label: '描述说明',
          children: description || '无'
        },
        {
          key: 'mockValue',
          label: '示例值',
          children: <JsonHighlightViewer data={mockValue} />
        }
      ]}
    />
  )
}
